// extracted by mini-css-extract-plugin
export default {"panel":"DesktopUserEnteringPanel_panel__80y5L"};